var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",on:{"click":_vm.changeRoute}},[(_vm.icon)?_c('i',{staticClass:"iconfont observer"},[_vm._v("")]):_vm._e(),_vm._v(_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }